import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M18.8 6.8v9.8a.6.6 0 1 0 1.2 0V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H9.4a.6.6 0 1 0 0 1.2h5.8c.86 0 1.432 0 1.873.037.425.035.62.096.744.16a1.8 1.8 0 0 1 .787.786c.063.123.124.318.159.744.036.44.037 1.013.037 1.873Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M4 9.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 5 7.12 5 8.8 5h3.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C17 7.28 17 8.12 17 9.8v7.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C14.72 22 13.88 22 12.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V9.8Zm8.2 11H8.8c-.86 0-1.433 0-1.873-.037-.426-.035-.62-.096-.744-.16a1.8 1.8 0 0 1-.787-.786c-.063-.123-.124-.318-.16-.744-.035-.44-.036-1.013-.036-1.873V9.8c0-.86 0-1.433.037-1.873.035-.426.096-.62.16-.744a1.8 1.8 0 0 1 .786-.787c.123-.063.318-.124.744-.16C7.367 6.202 7.94 6.2 8.8 6.2h3.4c.86 0 1.433 0 1.873.037.426.035.62.096.744.16a1.8 1.8 0 0 1 .787.786c.063.123.124.318.16.744.035.44.036 1.013.036 1.873v7.4c0 .86 0 1.433-.037 1.873-.035.426-.096.62-.16.744a1.8 1.8 0 0 1-.786.787c-.123.063-.318.124-.744.16-.44.035-1.013.036-1.873.036Z"
      clip-rule="evenodd"
    />
  </svg>
`;
